// Generated by purs version 0.15.16
import * as API_FormType from "../API.FormType/index.js";
import * as API_RecentForms from "../API.RecentForms/index.js";
import * as API_SelStudent from "../API.SelStudent/index.js";
import * as App_Browser from "../App.Browser/index.js";
import * as App_Route from "../App.Route/index.js";
import * as App_State from "../App.State/index.js";
import * as App_Step from "../App.Step/index.js";
import * as Concur_Core_Types from "../Concur.Core.Types/index.js";
import * as Concur_React from "../Concur.React/index.js";
import * as Control_Alt from "../Control.Alt/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Control_Monad_Trans_Class from "../Control.Monad.Trans.Class/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as GraphQL_Join from "../GraphQL.Join/index.js";
import * as GraphQL_Query from "../GraphQL.Query/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
import * as Internal_SelectionMap from "../Internal.SelectionMap/index.js";
import * as Routing_PushState from "../Routing.PushState/index.js";
import * as Steps_WorkQueue_Cache from "../Steps.WorkQueue.Cache/index.js";
import * as Steps_WorkQueue_State from "../Steps.WorkQueue.State/index.js";
import * as Steps_WorkQueue_UIState from "../Steps.WorkQueue.UIState/index.js";
import * as Widgets_Loading from "../Widgets.Loading/index.js";
var ordRNTY = /* #__PURE__ */ GraphQL_Type.ordRNTY(Data_Ord.ordString);
var selectAll$prime = /* #__PURE__ */ Internal_SelectionMap["selectAll$prime"](ordRNTY)(Data_Functor.functorArray)(Data_Foldable.foldableArray);
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect_Aff.applicativeAff);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var bind = /* #__PURE__ */ Control_Bind.bind(Effect_Aff.bindAff);
var getQuery = /* #__PURE__ */ GraphQL_Join.getQuery(GraphQL_Query.joinGenQ);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Either.functorEither);
var sequence = /* #__PURE__ */ Data_Traversable.sequence(Data_Traversable.traversableArray)(Data_Either.applicativeEither);
var getDecode = /* #__PURE__ */ GraphQL_Join.getDecode(GraphQL_Query.joinGenQ);
var eqRNTY = /* #__PURE__ */ GraphQL_Type.eqRNTY(Data_Eq.eqString);
var elem = /* #__PURE__ */ Data_Array.elem(eqRNTY);
var selectForms = /* #__PURE__ */ API_FormType.selectForms(Data_Functor.functorArray)(Data_Foldable.foldableArray);
var runGraphQL = /* #__PURE__ */ GraphQL_Join.runGraphQL(GraphQL_Query.qgql);
var nub = /* #__PURE__ */ Data_Array.nub(ordRNTY);
var eq = /* #__PURE__ */ Data_Eq.eq(eqRNTY);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var bind1 = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Effect_Aff.monadAff));
var pure1 = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Effect_Aff.monadAff));
var lift = /* #__PURE__ */ Control_Monad_Trans_Class.lift(Control_Monad_Except_Trans.monadTransExceptT)(Effect_Aff.monadAff);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Effect_Aff.monadEffectAff);
var routeForState = function (locationState) {
    return function (state) {
        return App_Route.routeForStepAndWorkQueueState(locationState)(state.step)(state.workQueueState);
    };
};
var applyStudentSelections = function (workQueue) {
    return function (students) {
        var selected = selectAll$prime(students)(Internal_SelectionMap.empty)(true);
        return {
            forms: workQueue.forms,
            documents: workQueue.documents,
            editDocs: workQueue.editDocs,
            currentDoc: workQueue.currentDoc,
            semester: workQueue.semester,
            teacher: workQueue.teacher,
            students: selected
        };
    };
};
var hydrateStudentSelections = function (workQueue) {
    return function (studentIds) {
        if (Data_Array["null"](studentIds)) {
            return pure(new Data_Either.Right(workQueue));
        };
        if (Data_Boolean.otherwise) {
            var queries = map(API_SelStudent.fetchStudentById)(studentIds);
            return bind(Control_Monad_Except_Trans.runExceptT(GraphQL_Join.runMultiQuery(map(getQuery)(queries))))(function (batchResult) {
                if (batchResult instanceof Data_Either.Left) {
                    return pure(new Data_Either.Left(batchResult.value0));
                };
                if (batchResult instanceof Data_Either.Right) {
                    return pure(map1(applyStudentSelections(workQueue))(sequence(Data_Array.zipWith(getDecode)(queries)(batchResult.value0))));
                };
                throw new Error("Failed pattern match at App.Hydrate (line 157, column 9 - line 160, column 115): " + [ batchResult.constructor.name ]);
            });
        };
        throw new Error("Failed pattern match at App.Hydrate (line 151, column 1 - line 151, column 106): " + [ workQueue.constructor.name, studentIds.constructor.name ]);
    };
};
var applyFormSelections = function (formIds) {
    return function (workQueue) {
        return function (forms) {
            var selected = Data_Array.filter(function (form) {
                return elem(form.id)(formIds);
            })(forms);
            var selectedMap = selectForms(selected)(true)(API_FormType.emptyFormPickerMap);
            return {
                students: workQueue.students,
                documents: workQueue.documents,
                editDocs: workQueue.editDocs,
                currentDoc: workQueue.currentDoc,
                semester: workQueue.semester,
                teacher: workQueue.teacher,
                forms: selectedMap
            };
        };
    };
};
var hydrateFormSelections = function (workQueue) {
    return function (formIds) {
        if (Data_Array["null"](formIds)) {
            return pure(new Data_Either.Right(workQueue));
        };
        if (Data_Boolean.otherwise) {
            return bind(runGraphQL(API_FormType.formListQuery))(function (formsResult) {
                return pure(map1(applyFormSelections(formIds)(workQueue))(formsResult));
            });
        };
        throw new Error("Failed pattern match at App.Hydrate (line 138, column 1 - line 138, column 100): " + [ workQueue.constructor.name, formIds.constructor.name ]);
    };
};
var resolveRoute = function (v) {
    return function (v1) {
        if (v instanceof App_Route.RStep3 && v.value0.activeDoc instanceof Data_Maybe.Just) {
            var v2 = Steps_WorkQueue_Cache.getDoc(v1)(v.value0.activeDoc.value0);
            if (v2 instanceof Data_Maybe.Just) {
                var committed = Steps_WorkQueue_State.setCurrentDoc(v1)(new Data_Maybe.Just({
                    formId: v2.value0.formId,
                    studentId: v2.value0.student.id,
                    documentId: new Data_Maybe.Just(v2.value0.id)
                }));
                return pure(new Data_Either.Right(new Data_Tuple.Tuple(new App_Step.Step3Doc(v.value0.activeDoc.value0), committed)));
            };
            if (v2 instanceof Data_Maybe.Nothing) {
                var requestedDocs = nub(Data_Array.cons(v.value0.activeDoc.value0)(v.value0.docs));
                var existingDocs = Data_Array.filter(function (form) {
                    return elem(form.id)(requestedDocs);
                })(v1.editDocs);
                var existingIds = map(function (v3) {
                    return v3.id;
                })(existingDocs);
                var missingDocs = Data_Array.filter(function (doc) {
                    return !elem(doc)(existingIds);
                })(requestedDocs);
                return bind((function () {
                    var $51 = Data_Array["null"](missingDocs);
                    if ($51) {
                        return pure(new Data_Either.Right([  ]));
                    };
                    return runGraphQL(API_RecentForms.fetchRecentFormsByIds(missingDocs));
                })())(function (fetchResult) {
                    if (fetchResult instanceof Data_Either.Left) {
                        return pure(new Data_Either.Left(fetchResult.value0));
                    };
                    if (fetchResult instanceof Data_Either.Right) {
                        var fetched = Data_Array.mapMaybe(function (requestedId) {
                            return Data_Array.find(function (form) {
                                return eq(form.id)(requestedId);
                            })(fetchResult.value0);
                        })(requestedDocs);
                        var combinedDocs = append(existingDocs)(fetched);
                        var v3 = Data_Array.find(function (form) {
                            return eq(form.id)(v.value0.activeDoc.value0);
                        })(combinedDocs);
                        if (v3 instanceof Data_Maybe.Just) {
                            var workQ = Steps_WorkQueue_State.editDocsWorkQueue(v1)(combinedDocs);
                            var current = new Data_Maybe.Just({
                                formId: v3.value0.form_type.id,
                                studentId: v3.value0.student.id,
                                documentId: new Data_Maybe.Just(v3.value0.id)
                            });
                            var committed = Steps_WorkQueue_State.setCurrentDoc(workQ)(current);
                            return pure(new Data_Either.Right(new Data_Tuple.Tuple(new App_Step.Step3Doc(v.value0.activeDoc.value0), committed)));
                        };
                        if (v3 instanceof Data_Maybe.Nothing) {
                            return pure(new Data_Either.Right(new Data_Tuple.Tuple(App_Step.Step1.value, v1)));
                        };
                        throw new Error("Failed pattern match at App.Hydrate (line 102, column 21 - line 113, column 65): " + [ v3.constructor.name ]);
                    };
                    throw new Error("Failed pattern match at App.Hydrate (line 95, column 13 - line 113, column 65): " + [ fetchResult.constructor.name ]);
                });
            };
            throw new Error("Failed pattern match at App.Hydrate (line 76, column 5 - line 113, column 65): " + [ v2.constructor.name ]);
        };
        if (v instanceof App_Route.RStep3 && v.value0.activeDoc instanceof Data_Maybe.Nothing) {
            if (Data_Array["null"](Steps_WorkQueue_State.getFillQueue(v1))) {
                return pure(new Data_Either.Right(new Data_Tuple.Tuple(App_Step.Step1.value, v1)));
            };
            if (Data_Boolean.otherwise) {
                return pure(new Data_Either.Right(new Data_Tuple.Tuple(App_Step.Step3.value, v1)));
            };
        };
        if (v instanceof App_Route.RStep2A) {
            return bind(hydrateFormSelections(v1)(v.value0.selectedForms))(function (result) {
                return pure(map1(Data_Tuple.Tuple.create(App_Step.Step2A.value))(result));
            });
        };
        if (v instanceof App_Route.RStep2B) {
            if (Data_Array["null"](v.value0.selectedStudents)) {
                return bind(hydrateFormSelections(v1)(v.value0.selectedForms))(function (result) {
                    return pure(map1(Data_Tuple.Tuple.create(App_Step.Step2A.value))(result));
                });
            };
            if (Data_Boolean.otherwise) {
                return bind(hydrateFormSelections(v1)(v.value0.selectedForms))(function (formResult) {
                    if (formResult instanceof Data_Either.Left) {
                        return pure(new Data_Either.Left(formResult.value0));
                    };
                    if (formResult instanceof Data_Either.Right) {
                        return bind(hydrateStudentSelections(formResult.value0)(v.value0.selectedStudents))(function (studentResult) {
                            return pure(map1(Data_Tuple.Tuple.create(App_Step.Step2B.value))(studentResult));
                        });
                    };
                    throw new Error("Failed pattern match at App.Hydrate (line 129, column 9 - line 133, column 56): " + [ formResult.constructor.name ]);
                });
            };
        };
        return pure(new Data_Either.Right(new Data_Tuple.Tuple(App_Route.routeToStep(v), v1)));
    };
};
var deriveAppState = function (state) {
    return function (locationState) {
        return Control_Monad_Except_Trans.runExceptT((function () {
            var requestedRoute = App_Route.parseRoute(locationState);
            return bind1(resolveRoute(requestedRoute)(state.workQueueState))(function (v) {
                var nextState0 = {
                    operations: state.operations,
                    pushStateInterface: state.pushStateInterface,
                    route: state.route,
                    routeVersion: state.routeVersion,
                    step1: state.step1,
                    step2A: state.step2A,
                    step2B: state.step2B,
                    step3: state.step3,
                    workQueueCache: state.workQueueCache,
                    workQueueUi: state.workQueueUi,
                    step: v.value0,
                    workQueueState: v.value1,
                    preselectForms: [  ]
                };
                var nextState = {
                    operations: nextState0.operations,
                    preselectForms: nextState0.preselectForms,
                    pushStateInterface: nextState0.pushStateInterface,
                    routeVersion: nextState0.routeVersion,
                    step: nextState0.step,
                    step1: nextState0.step1,
                    step2A: nextState0.step2A,
                    step2B: nextState0.step2B,
                    step3: nextState0.step3,
                    workQueueCache: nextState0.workQueueCache,
                    workQueueState: nextState0.workQueueState,
                    workQueueUi: nextState0.workQueueUi,
                    route: routeForState(locationState)(nextState0)
                };
                return pure1(App_State.syncStepSessions(state)(nextState));
            });
        })());
    };
};
var loadAppState = /* #__PURE__ */ Control_Monad_Except_Trans.runExceptT(/* #__PURE__ */ bind1(/* #__PURE__ */ lift(/* #__PURE__ */ liftEffect(Routing_PushState.makeInterface)))(function (pushStateInterface) {
    return bind1(lift(liftEffect(App_Browser.readLocation(pushStateInterface))))(function (locationState) {
        return bind1(Steps_WorkQueue_Cache.loadWorkQueue(Steps_WorkQueue_State.initialWorkQueueState)(Steps_WorkQueue_UIState.initialWorkQueueUiState)(Steps_WorkQueue_Cache.initialWorkQueueCache))(function (workQueue) {
            var initial = App_State.initialAppState({
                route: new App_Route.RHome({
                    preservedQuery: App_Route.preserveQuery(locationState.search)
                }),
                step: App_Step.Step1.value,
                workQueueState: workQueue.state,
                workQueueUi: workQueue.ui,
                workQueueCache: workQueue.cache,
                preselectForms: [  ],
                pushStateInterface: pushStateInterface
            });
            return deriveAppState(initial)(locationState);
        });
    });
}));
var loadAppStateWidget = /* #__PURE__ */ Control_Alt.alt(/* #__PURE__ */ Concur_Core_Types.altWidget(Data_Monoid.monoidArray))(Widgets_Loading.loadingWidget)(/* #__PURE__ */ Concur_React.affAction(loadAppState));
export {
    loadAppStateWidget,
    loadAppState,
    deriveAppState,
    resolveRoute,
    routeForState
};
//# sourceMappingURL=index.js.map
